export default __webpack_public_path__ + "static/summer_containers37-fc57255a867be793e2046f0de2097391.webp";